export default {
	'app.language.en-US': 'English',

	'app.Yes': 'Oui',
	'app.No': 'Non',

	'user.onHold':
		'Vous ne pouvez pas passer une commande pour l’instant; veuillez communiquer avec votre directeur commercial pour obtenir plus de détails.',

	'chooseColor.isPack':
		'Cet élément configurable fait partie intégrante d’un ensemble. Veuillez inscrire Ajouter au panier avant de sélectionner Choisir une couleur.',
	'chooseColor.NegativeQuantity': 'Nombre doit être positif.',

	'dates.start_date_after_end':
		'La date de début ne peut pas être supérieure à la date de fin.',
	'dates.too_far_back': 'Seuls les 12 derniers mois sont disponibles.',
	'dates.cant_see_future':
		'Vous ne pouvez pas sélectionner une date ultérieure.',
	'dates.invalid_start_date': 'La date de début n’est pas une date valide.',
	'dates.invalid_end_date': 'La date de fin n’est pas une date valide.',

	'orderdetails.status.InProcess': 'In Process',
	'orderdetails.status.Open': 'Open',
	'orderdetails.status.Completed': 'Completed',
	'orderdetails.NotAvailable': 'Order {orderNumber} is not available.',
	'orderDetails.headerText': 'Détails de la commande SOLO: ',

	OrderHistory_InvalidInput: 'Input invalid. Try again with different values.',

	'itemSearch.invalidQuery': 'Invalid item name.',
	'itemSearch.invalidNumber': "Invalide Numéro de l'article",
	'item.See_Components': 'Voir les composants',
	'item.soldOut': 'Article épuisé',
	'item.CannotOrderItems':
		"Vous ne pouvez pas passer une commande puisque vous n'expédiez pas à titre de franchisé.",
	'itemdetails.ItemDetails_Unauthorized': 'Article non disponible.',
	'packdetails.ItemSearch_InvalidInput': 'Article non disponible.',

	'addtocart.InvalidQuantity':
		'La quantité entrée est non valide, veuillez entrer une quantité valide.',
	'addtocart.GreaterQuantity':
		'La quantité entrée est supérieure à la quantité disponible {available_quantity}, veuillez entrer une quantité valide.',
	'addtocart.SubmitError':
		'La quantité disponible est uniquement de {available_quantity_on_submit}; veuillez mettre à jour avant de soumettre de nouveau.',
	'addtocart.SubmitErrorSoldOut':
		'Item is sold out. Please remove before resubmitting.',
	'addtocart.CartGreaterQuantity':
		'Vous avez {quantity_in_cart} article(s) dans votre panier; vous ne pouvez pas en ajouté plus que {available_quantity} article(s).',
	'addtocart.Cart_InvalidItems':
		'Certains des articles affichent des quantités non valides.',
	'addtocart.MaximumQuantity':
		'Vous avez déjà commandé la quantité maximale. Vous ne pouvez pas commander plus.',
	'addtocart.EmptyField':
		'La quantité entrée est non valide, veuillez entrer une quantité valide.',
	'addtocart.ItemIsPreview':
		'Vous ne pouvez pas commander à partir d’un APERÇU de promotion.',
	'addtocart.Unauthorized_Method': 'Commande d’article non autorisée.',
	'addtocart.Cart_ItemIsPreview':
		'Les articles de l’aperçu ne peuvent être ajoutés au panier.',
	'addtocart.Cart_ItemNotFoundInPromotions':
		'Article introuvable dans les promotions.',
	'addtocart.Cart_NotEnoughAvailableQuantity':
		'Vous ne pouvez pas ajouter plus d’articles que la quantité disponible.',
	'addtocart.DropShip_ItemNotInCart': 'Item is not in cart.',
	'addtocart.InternalServerError':
		'Un problème est survenu lors de votre commande. Veuillez actualiser la page ou essayer de nouveau plus tard.',
	'addtocart.Submit_InvalidRequest':
		'Un problème est survenu lors de votre commande. Veuillez actualiser la page ou essayer de nouveau plus tard.',
	'addtocart.Cart_InvalidRequest':
		'Nous sommes désolés, nous éprouvons des problèmes techniques.',

	/* Api error codes */
	'addtocart.request_failed':
		'Nous sommes désolés, nous éprouvons des problèmes techniques.',
	'impersonation.request_failed':
		'Nous sommes désolés, nous éprouvons des problèmes techniques.',
	'itemdetails.request_failed':
		'Nous sommes désolés, nous éprouvons des problèmes techniques.',
	'packdetails.request_failed':
		'Nous sommes désolés, nous éprouvons des problèmes techniques.',
	'offerings.request_failed':
		'Nous sommes désolés, nous éprouvons des problèmes techniques.',
	request_failed:
		'Nous sommes désolés, nous éprouvons des problèmes techniques.',
	'addtocart.Cart_IncorrectConfigurationsAddedInCart':
		'Un article configurable a une configuration invalide. Veuillez ajouter la quantité requise.',
	'impersonation.Impersonation_404':
		'Le n° de partenaire commercial LN # : {userId} est introuvable. Veuillez vérifier le numéro et essayer de nouveau.',
	'impersonation.Impersonation_Unauthorized':
		'Ce franchisé n’est pas disponible. Veuillez entrer le nom d’un autre franchisé.',
	'impersonation.impersonatedAs':
		'Vous consultez SOLO au nom de {name}{bpnumber}. Veuillez réouvrir une session pour consulter SOLO en votre nom.',
	'impersonation.instruction':
		"SI l'information est exacte, appuyer sur Continuer; sinon, rechercher un autre numéro de partenaire commercial ci-dessus.",
	'impersonation.User_Unauthorized':
		'User {userId} is not available. Please enter another LN Business Partner.',

	'offerings.ItemCategory_InvalidCategory':
		"Cette catégorie n'est pas disponible. ",
	'offerings.ItemSearch_InvalidInput': "Cette catégorie n'est pas disponible. ",

	'cart.dropShip':
		"Pour livrer directement un article à plus d'une adresse, ajouter l'article à chaque panier (chaque adresse).",
	'cart.newAddress.EmptyName': 'Le nom du magasin est manquant.',
	'cart.newAddress.InvalidName': 'Nom de magasin non valide.',
	'cart.newAddress.GreaterThanName':
		'Le champ Atelier ne peut comporter plus de 35 caractères. Veuillez entrer les données de nouveau.',
	'cart.newAddress.EmptyTechnician': 'Le nom du technicien est manquant.',
	'cart.newAddress.GreaterThanTechnician':
		'Le champ Technicien ne peut comporter plus de 30 caractères. Veuillez entrer les données de nouveau.',
	'cart.newAddress.InvalidTechnician': 'Nom du technicien non valide.',
	'cart.newAddress.EmptyAddress1': "L'adresse 1 est manquante.",
	'cart.newAddress.GreaterThanAddress1':
		'Le champ Adresse ligne 1 ne peut comporter plus de 100 caractères. Veuillez entrer les données de nouveau.',
	'cart.newAddress.InvalidAddress1': 'Adresse 1 non valide.',
	'cart.newAddress.GreaterThanAddress2':
		'Le champ Adresse ligne 2 ne peut comporter plus de 100 caractères. Veuillez entrer les données de nouveau.',
	'cart.newAddress.InvalidAddress2': 'Adresse 2 non valide.',
	'cart.newAddress.EmptyCity': 'La ville est manquante.',
	'cart.newAddress.InvalidCity': 'Ville non valide.',
	'cart.newAddress.GreaterThanCity':
		'Le champ Ville ne peut comporter plus de 30 caractères. Veuillez entrer les données de nouveau.',
	'cart.newAddress.EmptyZip': 'Le code postal est manquant.',
	'cart.newAddress.InvalidZip': 'Code postal non valide.',
	'cart.newAddress.GreaterThanZip':
		'Le champ Code postal ne peut comporter plus de 10 caractères. Veuillez entrer les données de nouveau.',
	'cart.newAddress.EmptyPhone': 'Le numéro de téléphone est manquant.',
	'cart.newAddress.InvalidPhone':
		'Veuillez inscrire le numéro de téléphone dans le format suivant : ###-###-####.',
	'cart.newAddress.InvalidPhoneAUS':
		'Veuillez inscrire le numéro de téléphone, incluant l’indicatif régional : ##########',
	'cart.newAddress.GreaterThanPhone':
		'Le champ Téléphone ne peut comporter plus de {max_length} caractères. Veuillez entrer les données de nouveau.',
	'cart.newAddress.EmptyEmail': 'Le courriel est manquant.',
	'cart.newAddress.InvalidEmail':
		'Veuillez entrer une adresse de courriel valide.',
	'cart.newAddress.GreaterThanEmail':
		'Le champ Courriel ne peut comporter plus de 50 caractères. Veuillez entrer les données de nouveau.',
	'cart.newAddress.CustomerCare':
		'Si vous croyez que les renseignements soumis sont exacts, veuillez communiquer avec le centre de service à la clientèle par telephone appel {customerPhone}.',
	'cart.newAddress.DuplicateDropship':
		'Une adresse de livraison directe de l’atelier "{dropshipName}" existe déjà',

	'general.addToCart': 'Ajouter au panier',
	'general.cancelText': 'Annuler',
	'general.chooseColorText': 'Choisir la couleur',
	'general.pleaseFillInMessage':
		"S'il vous plaît remplir dans les quantités souhaitées pour les promotions",
	'general.continueShopping': 'Continuer à magasiner',
	'general.noItemsAvailable': 'Aucun articles disponible.',
	'general.errorLoadingContent': 'Erreur de chargement du contenu	',
	'general.pleaseFillInTitle': "S'il vous plaît remplir les quantités",

	'header.yourCart': 'Votre panier',

	'navigation.home': 'Accueil',
	'navigation.orderHistory': 'Historique des commandes SOLO',
	'navigation.orderStatus': 'État de la commande',
	'navigation.salesReports': 'Rapports de ventes',
	'navigation.help': 'Aide de SOLO',

	'leftSideMenu.downloadSoloDetails': 'Télécharger les détails SOLO',
	'leftSideMenu.previewText': '*APERÇU* ',

	'home.pleaseNoteMessage':
		'S’il vous plait notez les quantites en Solo ne represent pas les quantites qui sont en stock mais seulement les quantites qui sont disponible au prix promo.',
	'hand-tools': 'Outils à main',
	'power-tools': 'Outils mécaniques',
	'tool-storage': 'Unités de rangement',
	'shop-and-tech': 'Atelier et technicien',
	diagnostics: 'Diagnostic',

	'productGroup.itemsIn': 'Article(s) dans',

	'offeringsPage.headerText': 'Offres',
	'offeringsPage.itemsIn': 'Articles dans',
	'offeringsPage.print': 'Imprimer',

	'itemSearch.headerText': 'Recherche de résultats pour ',
	'itemSearch.genericHeaderText': 'Rechercher',
	'itemSearch.itemsIn': 'Article(s)',
	'itemSearch.searchButton': 'Rechercher',
	'itemSearch.placeholderText': 'Recherche par n° d’article',
	'itemSearch.noItemsFound':
		'Aucun article n’a été trouvé dans cette recherche.',

	'orderHistory.itemsIn': 'Article(s)',
	'orderHistory.startDate': 'Commencer:',
	'orderHistory.endDate': 'Finir:',
	'orderHistory.showResults': 'Afficher les résultats',
	'orderHistory.concernMessage':
		'Si vous avez des questions concernant une commande, veuillez communiquer avec le centre de service à la clientèle par telephone appel ',
	'orderHistory.viewOrderHistoryTab': 'Afficher l’historique de commandes SOLO',
	'orderHistory.searchPartNumberTab': 'Rechercher numéro de pièce',
	'orderHistory.noOrdersFound':
		"Aucune commande n'a été trouvée pour le mois sélectionné. Veuillez sélectionner un autre mois.",
	'orderHistory.webReports':
		'L’état de toutes les commandes Snap-on est disponible dans ',
	'orderHistory.webReportsLink': 'les rapports Web.',
	'searchPart.title': 'Historique de commandes SOLO - No de produit :',
	'searchPart.searchText': 'Recherche de no de pièce:',
	'searchPart.itemsFound': 'article(s) trouvé(s)',
	'searchPart.noOrdersFound':
		'Aucune commande trouvée pour ce no de pièce. Sélectionner un autre no de pièce',
	'searchPart.searchPlaceholder': 'Recherche de no de pièce',

	'orderDetails.orderType': 'Type de commande:',
	'orderDetails.orderDate': 'Date de la commande:',
	'orderDetails.franchiseeNumber': 'No de client:',
	'orderDetails.poNumber': 'Numéro de référence:',
	'orderDetails.orderReference': 'Numéro de référence:',
	'orderDetails.totalOrderList': 'Montant de la commande:',
	'orderDetails.totalOrderNet': 'Montant total net de la commande:',
	'orderDetails.backToSearchPart': 'Retourner à Rechercher numéro de pièce',
	'orderDetails.backToOrderHistory': 'Retourner à Historique des commandes',
	'orderDetails.backToHome': "Retourner à Page d'accueil",

	'itemDetails.headerText': "Détails de l'article",

	'packDetails.headerText': 'Détails de l’ensemble',
	'packDetails.totalItemsInPackage':
		'{totalCount} totaux des articles dans le paquet',
	'packDetails.itemsInPackText': ' Articles dans l’ensemble',

	'cart.headerText': 'Panier',
	'cart.submitOrder': 'Soumettre la commande',
	'cart.updateCart': 'Mettre à jour le panier',
	'cart.cartSummary': 'Résumé Panier: ',
	'cart.itemsIn': ' article(s)',
	'cart.leaveCartMessage':
		'Vous avez des changements qui n’ont pas été sauvegardés. Si vous cliquez sur « Annuler », les changements ne seront pas enregistrés. Veuillez mettre à jour le panier.',
	'cart.cartUpdatedMessage': 'Le panier a été mis à jour.',
	'cart.noItemsAddedMessage':
		'Aucun article n\'a été ajouté à votre panier. Veuillez continuer à magasiner et cliquez sur le bouton "Ajouter au panier" pour les articles que vous souhaitez acheter.',
	'cart.itemsAddedMessage': 'Les articles ont été ajoutés à votre panier.',
	'cart.viewCartMessage': ' AFFICHER LE PANIER',
	'cart.footerTotals': 'Totaux',
	'cart.footerItemsText': ' articles',
	'cart.submitWithoutUpdate':
		'Des changements n’ont pas été enregistrés. Soumettre sans mettre à jour votre panier?',
	'cart.orderSubmitted': 'Commande soumise',
	'cart.thankYouMessage': 'Merci. Vous commande a été soumise avec succès.',
	'cart.emailConfirmationMessage':
		'Vous recevrez un courriel de confirmation avec tous les détails de votre commande.',
	'cart.leaveCartTitle': 'Laisser le panier',
	'cart.submitWithoutUpdatesYes': 'OUI',

	'dropShip.newDropshipTitle': 'Nouveau Adresse directe',
	'dropship.editDropshipTitle': 'Modifier Adresse directe',
	'dropship.nameLabel': 'Nom',
	'dropship.technicianLabel': 'Technicien',
	'dropship.address1Label': 'Adresse 1',
	'dropship.address2Label': 'Adresse 2',
	'dropship.countryLabel': 'Pays',
	'dropship.stateLabel': 'État/province',
	'dropship.cityLabel': 'Ville',
	'dropship.zipLabel': 'Code postal',
	'dropship.phoneLabel': 'Téléphone',
	'dropship.emailLabel': 'Courriel',
	'dropship.optionNone': 'Aucun',
	'dropship.optionNewAddress': 'Nouvelle adresse',
	'dropship.optionEditAddress': 'Modifier une adresse',
	'dropship.NotificationTitle': 'Drop Ship Notification',
	'dropship.Notification':
		'You have already updated the dropship on the same item twice. Please update the cart before udating dropship again.',

	'impersonation.modalTitle':
		"Rechercher un franchisé ou un magasin de l'entreprise",
	'impersonation.enterBPNumberText':
		'Veuillez inscrire le n° de partenaire commercial LN',
	'impersonation.pressContinueText':
		"SI l'information est exacte, appuyer sur Continuer; sinon, rechercher un autre numéro de partenaire commercial ci-dessus.",
	'impersonation.continueButton': 'Continuer',
	'impersonation.reverButton': 'Revenir',
	'impersonation.informationFoundText':
		'Les renseignements suivants ont été trouvés sur le numéro de partenaire commercial LN:',
	'impersonation.lnBusinessPartnerLabel': 'No de client:',
	'impersonation.nameLabel': 'Nom:',
	'impersonation.managerLabel': 'Directeur:',
	'impersonation.phoneLabel': 'Téléphone:',
	'impersonation.emailLabel': 'Courriel:',
	'impersonation.statusLabel': 'État:',
	'impersonation.searchPlaceholder': 'Partenaire commercial LN',
	'impersonation.searchForLNBP': 'Rechercher no part. comm. LN',
	'impersonation.expiredTitle': "L'emprunt d'identité a expiré",
	'impersonation.expiredText':
		"L'emprunt d'identité a été annulée en raison de l'inactivité",

	'itemsTable.soloItemColumn': 'Article Solo',
	'itemsTable.promoNameColumn': 'Nom de la promotion',
	'itemsTable.endDateColumn': 'Date de fin',
	'itemsTable.qtyColumn': 'Qté',
	'itemsTable.listColumn': 'Prix courant',
	'itemsTable.promoColumn': 'Prix spécial',
	'itemsTable.TAColumn': 'Éch.',
	'itemsTable.netColumn': 'Net',
	'itemsTable.estShipColumn': "Date approx. de  l'expédition",
	'itemsTable.numberHoldInvWksColumn': '# de semaines de factures en attente',
	'itemsTable.dropShipColumn': 'Adresse directe',
	'itemsTable.addToCartQtyColumn': 'Ajouter au panier',
	'itemsTable.soloItemPackNameColumn': "Article Solo / Nom de l'ensemble",
	'itemsTable.startDateColumn': 'Date de début',
	'itemsTable.itemQtyColumn': 'Qté articles',
	'itemsTable.extColumn': 'Prix total',
	'itemsTable.cartSoloItemColumn': "Article Solo/Nom de l'ensemble",
	'itemsTable.cartPromoColumn': 'Prix promotionnel',
	'itemsTable.cartQty': 'Qté panier',
	'itemsTable.cartShipDateColumn': "Date approx. de  l'expédition",
	'itemsTable.cartDropShipColumn': 'Adresse directe',
	'itemsTable.removeColumn': 'Retirer',
	'itemsTable.resultsPerPage': 'Résultats par page',
	'ordersTable.orderDateColumn': 'Date de la commande',
	'ordersTable.PONumberColumn': 'PO Numéro',
	'ordersTable.orderReference': 'Numéro de référence',
	'ordersTable.orderTypeColumn': 'Type de commande',
	'ordersTable.shipToNameColumn': 'Expédier à',
	'ordersTable.totalColumn': 'Total {currency}',
	'ordersTable.partNumberColumn': 'No de pièce',
	'ordersTable.descriptionColumn': 'Description',
	'ordersTable.orderedQtyColumn': 'Qté commandée',
	'ordersTable.estShipColumn': "Date approx. de  l'expédition",
	'ordersTable.unitPriceColumn': 'Prix unitaire',
	'ordersTable.extendedPriceColumn': 'Prix total',
	'ordersTable.lineNumberColumn': '#',
	'ordersTable.productNumberColumn': 'No de produit',
	'ordersTable.qtyColumn': 'Qté',
	'ordersTable.planDeliveryDateColumn': 'Prévu',

	'chooseColor.modalTitle': 'Sélection de couleur',
	'chooseColor.mustSelectError':
		'Vous devez sélectionner {totalQuantity} articles.',
	'chooseColor.itemQuantityBelowError':
		"Veuillez choisir une quantité inférieure à {quantity} pour l'article sélectionné.",
	'chooseColor.selectTotalQty':
		'Sélectionner {total} quantité totale - Sélectionné ',
	'chooseColor.notOnFile': 'N’est pas indiqué au dossier.',
	'chooseColor.qtyText': 'Qté:',

	'downloadPromotion.clickOnTypeMessage':
		'Cliquer sur le type de fichier que vous souhaitez télécharger pour ',
	'downloadPromotion.downloadPDF': 'Télécharger le fichier PDF',
	'downloadPromotion.downloadExcel': 'Télécharger le fichier Excel',
	'downloadPromotion.promotionText': 'Promotion',
	'downloadPromotion.categoryText': 'Catégorie',

	Unauthorized_Method: 'Commande d’article non autorisée.',

	'errorLoading.temporaryProblemText':
		'Un problème temporaire est survenu pendant le chargement du contenu de cette page.',
	'errorLoading.ifYouContinueMessage':
		'Si vous continuez de recevoir ce message, veuillez communiquer avec le centre de service à la clientèle par telephone appel {customerPhone}.',

	'confirmPromptModal.titleText': 'Confirmer',

	'unauthorizedMessage.noPermissionsText':
		"Vous n'êtes pas autorisé à voir cette page",
	'unauthorizedMessage.noPermissionsText2':
		"Il semble que vous n'ayez actuellement pas la permission d'accéder à cette page.",
	'unauthorizedMessage.nationalCareCenterMessage':
		"Si vous pensez que c'est une erreur, veuillez communiquer avec le centre de service à la clientèle par telephone appel {customerPhone}.",

	'packItemList.packContains': 'Cet ensemble contient {itemCount} articles',
	'packItemList.itemNumberColumn': 'N° d’article',
	'general.privacyPolicy': 'Politique de Confidentialité',
	'ok.Button': 'OK',
};



// WEBPACK FOOTER //
// ./src/ui/i18n/messages/fr_CA.js